import { Base } from "ui/Scripts/source/framework/base";
import { IMessageTypeListItem, MessageTypeListItem } from "../messageType/messageTypeListItem";
import { IMessageEditItem, MessageEditItem } from "./messageEditItem";
import { IIdTitleNode, IdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IMessageEdit {
    item: IMessageEditItem;
    hasNormalCompanyGroups: boolean;
    hasFixedCompanyGroups: boolean;
    canUseAllCompanyGroup: boolean;
    canSaveAndSendEmail: boolean;
    messageTypes: IMessageTypeListItem[];
    senderUnits: IIdTitleNode[];
    targetUnits: IIdTitleNode[];
}

export class MessageEdit implements IMessageEdit {
    item: MessageEditItem;
    hasNormalCompanyGroups: boolean;
    hasFixedCompanyGroups: boolean;
    canUseAllCompanyGroup: boolean;
    canSaveAndSendEmail: boolean;
    messageTypes: MessageTypeListItem[];
    senderUnits: IdTitleNode[];
    targetUnits: IdTitleNode[];

    constructor();
    constructor(obj: IMessageEdit);
    constructor(obj?: any) {
        this.item = new MessageEditItem(obj ? obj.item : null);
        this.hasNormalCompanyGroups = obj && obj.hasNormalCompanyGroups || false;
        this.hasFixedCompanyGroups = obj && obj.hasFixedCompanyGroups || false;
        this.canUseAllCompanyGroup = obj && obj.canUseAllCompanyGroup || false;
        this.canSaveAndSendEmail = obj && obj.canSaveAndSendEmail || false;
        this.messageTypes = Base.getTypedArray(obj ? obj.messageTypes : null, MessageTypeListItem);
        this.senderUnits = Base.getTypedArray(obj ? obj.senderUnits : null, IdTitleNode);
        this.targetUnits = Base.getTypedArray(obj ? obj.targetUnits : null, IdTitleNode);
    }
}